










import Vue from 'vue';
import LocalStorageHelper from '@/helpers/LocalStorageHelper';
import CookieHelper from '../../helpers/CookieHelper';

export default Vue.extend({
  name: `AcceptedCookieRevoke`,
  methods: {
    resetCookieSelection(): void {
      CookieHelper.getAllCookieNames().forEach((cookieName: string): void => {
        // in this case it does not work with specific functions, but we still don't want to set the remove function public.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        CookieHelper.removeCookie(cookieName);
      });
      CookieHelper.removeAll();
      LocalStorageHelper.removeAll();
      // in this case it does not work with specific functions, but we still don't want to set the remove function public.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      CookieHelper.removeCookie(`_fw_crm_v`, false);
      window.location.reload();
    },
  },
});
